import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import i18n from "./i18n";
import {I18nextProvider as I18nProvider} from 'react-i18next';
import GA from './googleAnalytic'

import TagManager from 'react-gtm-module'
const tagManagerArgs = {
  //gtmId: 'GTM-5BNGQLT' //the old one
  gtmId: 'GTM-57B4GT4P' //the new one from tm
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
          { GA.init() && <GA.RouteTracker /> }
            <I18nProvider i18n={i18n}>
                <App/>
            </I18nProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
